import { createContext } from 'react';
export const defaultContext = {
    isDisabled: false,
    isFocused: false,
    isHovering: false,
    isSelected: false,
};
/** Create separate contexts to limit how often things rerender. */
export const createInputStateContext = () => (createContext(defaultContext));
export const CheckboxInputStateContext = createInputStateContext();
export const RadioInputStateContext = createInputStateContext();
export const PickerOptionInputStateContext = createInputStateContext();
// TOOD: Do we need to create a hook like usePickerOptionInputStateContext for this?
export const TextLinkInputStateContext = createInputStateContext();
